<div *ngIf="!isWaitPoup" id="feedback__Modal" class="feedback__modal" style="display: flex;">
    <!-- Modal content -->
    <div class="modal-content">
        <div class="feedback__modal--warnig--msg" style="text-align: center;">
            <img src="assets/images/sad.png" alt="" width="80" style="margin: auto;">
            <p class="feedback__Modal--username">Hey {{user?.firstName}}!</p>
            <p class="feedback__Modal--coursename">You didn't meet the attendance threshold required
                to mark this Masterclass as complete.
            </p>
            <p class="feedback__Modal--coursename">Don't worry, a recording of the complete session
                will be available here shortly. Watch it at your convenience to complete the Masterclass module.</p>
            <button (click)="closeModal()">
                OKAY, GOT IT
            </button>
        </div>
    </div>
</div>

<div *ngIf="isWaitPoup" id="feedback__Modal" class="feedback__modal" style="display: flex;">
    <!-- Modal content -->
    <div class="modal-content">
        <div class="feedback__modal--warnig--msg" style="text-align: center;">
            <!-- <img src="assets/images/sad.png" alt="" width="80" style="margin: auto;"> -->
            <p class="feedback__Modal--username">Hey {{user?.firstName}}!</p>
            <p class="feedback__Modal--coursename">Your attendance for this Masterclass is being updated. 
            </p>
            <p class="feedback__Modal--coursename">
                It will be synced within the next 48 hours. We'll make sure it reflects soon — no action needed from your side.
            </p>
            <button (click)="closePreModal()">
                OKAY, GOT IT
            </button>
        </div>
    </div>
</div>